export const getEcommerceSearchOverlayResultsMessage = (queryUsed: string, totalResults: number) =>
    `Resultat som innehåller "${queryUsed}" (${totalResults} träffar).`;
